/**
 * Datos fijos de la ferreteria.
 *
 * Estan en un solo lugar porque se repiten en la cabecera, el pie, los enlaces
 * de WhatsApp y los datos estructurados: si el telefono cambia, cambia aca.
 *
 * Pendiente: la direccion, el horario y el numero de WhatsApp los confirma el
 * cliente (requisitos-tecnicos.md). Lo que hay son los datos publicos del sitio
 * actual.
 *
 * Lo que NO va aca son las condiciones de despacho: el monto de despacho gratis
 * y las tarifas por region las administra el backoffice (ADM-10) y llegan por
 * `contexto/despacho.tsx`. Escribirlas aca era garantizar que el panel y la
 * tienda dijeran cosas distintas.
 */

export const SITIO = {
  nombre: 'El Carpintero',
  nombreLargo: 'Ferretería El Carpintero',
  /**
   * El logo, con version en la URL. El 02-10-2026 Caddy respondio por error un
   * 301 en `/marca/logo.webp` y los navegadores guardan esa redireccion sin
   * vencimiento: una URL nueva es lo unico que la saltea. Si el archivo cambia,
   * se sube la version (aca, en `index.html` y en el correo del backend).
   */
  logo: '/marca/logo.webp?v=2',
  /** La empresa detras de la tienda, como la identifican los textos legales. */
  razonSocial: 'Caso e Hijos SpA',
  rut: '80.173.900-8',
  descripcion:
    'Herrajes, herramientas y materiales para el carpintero, el mueblista y el tapicero. Stock real, despacho a todo Chile y asesoría de taller.',
  /** Base de las URL canonicas. En produccion la fija la variable de entorno. */
  urlBase: import.meta.env.VITE_URL_SITIO ?? 'https://www.elcarpintero.cl',
  direccion: {
    calle: 'San Diego 820',
    comuna: 'Santiago',
    region: 'Región Metropolitana',
    pais: 'CL',
  },
  /**
   * Identificador de la ficha del negocio en Google Maps (CID).
   *
   * Apunta a la ficha de "Ferreteria El Carpintero", no a una busqueda por
   * direccion: quien pulsa el mapa llega a la tienda con sus horarios, sus
   * fotos y sus resenas, no a un punto en una calle.
   *
   * Es el numero que Google usa internamente para el local, y sale del par
   * `!1s0x...:0x7ef3297d06986885` de la URL de la ficha. Se guarda asi, y no la
   * URL larga que copia el navegador, porque esa arrastra parametros de sesion
   * (`entry`, `g_ep`) que Google rota y que quedarian congelados en el codigo.
   * De aca salen tanto el mapa embebido como el enlace del pie.
   */
  mapaCid: '9147700885077911685',
  telefono: '+56 2 2698 4785',
  email: 'portal@elcarpintero.cl',
  whatsapp: '56933772382',
  whatsappVisible: '+56 9 3377 2382',
  horario: 'Lunes a viernes 9:30 a 18:00 · Sábado 10:00 a 13:00',
  /**
   * Taller de fabricacion y afilado, tal como lo publicaba el sitio viejo
   * (`/servicios`). Los tecnicos y sus celulares los confirmo el usuario el
   * 02-10-2026.
   */
  taller: {
    email: 'taller@elcarpintero.cl',
    contactos: [
      { nombre: 'Francisco Valdés', telefono: '+56 9 9827 4553' },
      { nombre: 'Sergio Rodríguez', telefono: '+56 9 9827 4537' },
      { nombre: 'Sebastián Rodríguez', telefono: '+56 9 8724 4875' },
    ],
  },
  redes: {
    instagram: 'https://www.instagram.com/elcarpinteroficial/',
    facebook: 'https://www.facebook.com/elcarpinterocl',
  },
} as const;
